<template>
  <ModalComponent :show="show" @close="hide">
    <Pricing :value="data.addon" :options="data.options" theme="flat" @assisted="$ev => (assisted = $ev)">
      <template #actions>
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="hide" />
        <ButtonComponent
          :label="$t('activate')"
          :icon="['fal', 'plus']"
          theme="primary"
          :labels="{ confirm: $t('confirm') }"
          :icons="{ confirm: ['fas', 'question-circle'] }"
          confirm
          @click="action"
          @onSuccess="() => hide(false)"
          :promise="data.promise"
          :disabled="assisted"
        />
      </template>
    </Pricing>
  </ModalComponent>
</template>

<script>
import Bus from '@/bus'

import { ModalComponent } from 'vue-elder-modal'
import Pricing from '@/components/Pricing'

export default {
  data() {
    return {
      data: {
        addon: null,
        action: null,
        options: null,
        promise: null,
        onResolve: null,
        onReject: null,
      },
      show: false,
      assisted: false,
    }
  },
  methods: {
    action() {
      this.data.promise = this.data
        .action()
        .then(response => this.data.onResolve(response))
        .catch(err => {
          this.data.onReject(err)
          throw err
        })
    },
    hide(reject = true) {
      this.show = false
      if (reject) this.data.onReject()
    },
    reset() {
      Object.keys(this.data).forEach(key => (this.data[key] = null))
    },
  },
  mounted() {
    Bus.on('pricing:show', ({ addon, action, options }) => {
      this.reset()

      return new Promise((resolve, reject) => {
        this.data.addon = addon
        this.data.action = action
        this.data.options = options
        this.data.onResolve = resolve
        this.data.onReject = reject
        this.show = true
      })
    })
  },
  components: {
    ModalComponent,
    Pricing,
  },
}
</script>
